import React, { useMemo } from "react";
import styles from "./SectionList.module.css";
import { isNonEmptyArray } from "../../../../../../common/utils";
import { SectionRow } from "./SectionRow";
import { translate } from "../../../../../../common/providers";

function flattenSections(sections) {
	const result = [];
	for (const section of sections) {
		if (isNonEmptyArray(section.layout)) {
			result.push({ ...section, subsection: [] });
		}
		if (isNonEmptyArray(section.subsection)) {
			for (const sub of section.subsection) {
				if (isNonEmptyArray(sub.layout)) {
					result.push({ ...sub, subsection: [] });
				}
			}
		}
	}
	return result;
}

function filterSection(sections, selectedId) {
	for (const section of sections) {
		if (section.uuid === selectedId) {
			return [section];
		}
		const matchedSub = section.subsection?.find((sub) => sub.uuid === selectedId);
		if (matchedSub) {
			return [
				{
					...section,
					layout: [],
					subsection: [matchedSub],
				},
			];
		}
	}
	return [];
}

export const SectionList = ({
	detectedValues,
	launchInProgress = null,
	sections,
	selectedSection,
	selectedCriteria,
	onSelectCriteria,
}) => {
	const isAllMode = !selectedSection;
	const currentList = useMemo(() => {
		if (!isNonEmptyArray(sections)) {
			return [];
		}
		if (!selectedSection) {
			return flattenSections(sections);
		}
		return filterSection(sections, selectedSection);
	}, [sections, selectedSection]);
	return (
		<div className={styles.mainList}>
			{isNonEmptyArray(currentList) && (
				<>
					{isAllMode && (
						<div className={styles.section}>{translate("dashboards.project-sheet.criteria.list.all")}</div>
					)}
					{currentList.map((section) => (
						<SectionRow
							key={section?.id || section?.uuid || section?.name}
							detectedValues={detectedValues}
							isAllMode={isAllMode}
							launchInProgress={launchInProgress}
							section={section}
							selectedCriteria={selectedCriteria}
							onSelectCriteria={onSelectCriteria}
						/>
					))}
				</>
			)}
		</div>
	);
};
